import { render } from "./BasicInfo.vue?vue&type=template&id=1f7d3d65&scoped=true&ts=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"

import "./BasicInfo.vue?vue&type=style&index=0&id=1f7d3d65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7d3d65"]])

export default __exports__